import React from 'react'
import AppLayout from '../components/AppLayout'

// Generic placeholder for pages being built
function Placeholder({ title, icon, description }) {
  return (
    <AppLayout title={title}>
      <div className="section-header">
        <div className="section-icon">{icon}</div>
        <div className="section-info">
          <h2>{title}</h2>
          <p>{description}</p>
        </div>
      </div>
      <div className="card">
        <div className="empty-state">
          <div className="empty-icon">{icon}</div>
          <h3>{title}</h3>
          <p style={{ maxWidth: 400, margin: '8px auto 0' }}>
            This section is set up and ready. The database tables are configured —
            you can begin entering data once the Supabase connection is active.
          </p>
        </div>
      </div>
    </AppLayout>
  )
}

export const HarvestLog = () => <Placeholder title="Harvest Log" icon="🌾" description="Record daily harvest weights, grades, and quality by crop" />
export const Quality = () => <Placeholder title="Quality Control" icon="✅" description="Weekly quality audits, food safety checklists, and traceability" />
export const Logistics = () => <Placeholder title="Logistics" icon="🚚" description="Outbound delivery checklists, receiving logs, cold chain records" />
export const Invoices = () => <Placeholder title="Invoices" icon="📄" description="Track all invoices, payment status, and overdue amounts" />
export const WeeklyPL = () => <Placeholder title="Weekly P&L" icon="📊" description="Weekly profit and loss summary for Edward and Sharon to review" />
export const Procurement = () => <Placeholder title="Procurement" icon="📦" description="Purchase orders, supplier list, stock reorder levels" />
export const Timesheets = () => <Placeholder title="Timesheets" icon="⏱️" description="Weekly staff timesheets — auto-calculates hours and pay" />
export const Visitors = () => <Placeholder title="Visitor Log" icon="👤" description="Log every visitor to the farm — required for food safety compliance" />
export const Incidents = () => <Placeholder title="Incident Reports" icon="🚨" description="Record any accident, security issue, or crop emergency" />
export const SOPs = () => <Placeholder title="SOPs & Guides" icon="📋" description="Standard operating procedures for all farm operations" />
export const Emergency = () => <Placeholder title="Emergency Plan" icon="🆘" description="What to do in fire, flood, power failure, crop disease, and break-in" />
export const AdminReports = () => <Placeholder title="Reports" icon="📈" description="Business reports — income trends, harvest yields, staff hours" />
export const AdminInvites = () => <Placeholder title="Invite Staff" icon="✉️" description="Send invitation links to new team members" />
